import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { CmsNavbarService } from '../cms-navbar/cms-navbar.service';
import { SearchResultsService } from '../search-results/search-results.service';
import { TriBulletinService } from './tri-bulletin.service';
import { NgIf, NgFor, NgStyle, NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { SortByFilterPipe } from '../../shared/pipes/sort-by-filter.pipe';
import { FilterResultsPipe } from '../../shared/pipes/filter-results.pipe';
import { LoadMoreItemsPipe } from '../../shared/pipes/load-more-items.pipe';
import { BrandTypePipe } from '../../shared/pipes/brand-type.pipe';

@Component({
    selector: 'app-tri-bulletins-home',
    templateUrl: './tri-bulletins-home.component.html',
    styleUrls: ['./tri-bulletins-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgFor,
        NgStyle,
        RouterLink,
        NgClass,
        DatePipe,
        SearchFilterPipe,
        SortByFilterPipe,
        FilterResultsPipe,
        LoadMoreItemsPipe,
        BrandTypePipe,
    ],
})
export class TriBulletinsHomeComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public isShowAll = false;
  public isShowNew = true;
  public isShowHistory = false;
  public isShowSaved = false;
  public newDocsCount: number;
  public triBulletins: any;
  APP_SETTINGS: any;
  public serviceError = 'Loading data. Please wait...';
  public search4bulletins;
  // side bar or modal variables
  public mainGroupList = [];
  public bodyTypeList = [];
  public fromYears: number[] = [];
  public toYears: number[] = [];
  private currentYear: number;
  public sortBy = [];
  public inputMainGroup;
  public inputSeries = '';
  public inputSeriesGroup;
  public inputBody;
  public inputFromYear;
  public inputToYear;
  public inputSortBy;
  public filter = { group: '', series: '', body: '', from: '', to: '' };
  public expandPbs = {};

  // variables to update sort icons
  isDesc = false;
  column = '';
  direction: number;

  public numOfItems;

  username: string;
  errorMessage: string;
  noContent: boolean;
  redirectOnFirstVisit: boolean = true;

  // bulletinLabel addedd for is Motorrad --Vishal
  bulletinLabel = 'TRI Bulletins';
  userRoles = {};

  constructor(
    private utilityService: UtilityService,
    private changeDetector: ChangeDetectorRef,
    private bulletinService: TriBulletinService,
    private searchResultsService: SearchResultsService,
    private authService: AuthService,
    private cmsNavbar: CmsNavbarService,
    private spinnerService: SpinnerService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.subscription = [];
    this.username = this.authService.getUserName();
    // this.subscription.push(this.cmsNavbar.getMainGroupsList().subscribe(data => {
    //   this.mainGroupList = data;
    // }));
    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
    
    this.APP_SETTINGS = APP_SETTINGS;

   

    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
      this.bulletinLabel = "Authority Bulletins";
    }
    else {
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }
    this.search4bulletins = (APP_SETTINGS.currentPage == 'tri') ? this.bulletinService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'tri';

    this.sortBy = [
      { key: 'bulletinNumber', value: 'Bulletin Number' },
      { key: 'description', value: 'Bulletin Title' },
      { key: 'releaseDate', value: 'Date' }
    ];
    this.bodyTypeList = this.initializeBodyTypes();

    this.currentYear = (new Date()).getFullYear();
    for (let year: number = 1985; year < this.currentYear + 1; year++) {
      this.fromYears.push(year);
      this.toYears.push(year);
    }
    this.triBulletins = [];

    // this.showNew();

    if (APP_SETTINGS.triBulletins == 'all') { this.showAll(); }
    if (APP_SETTINGS.triBulletins == 'new') { this.showNew(); }
    if (APP_SETTINGS.triBulletins == 'history') { this.showHistory(); }
    if (APP_SETTINGS.triBulletins == 'saved') { this.showSaved(); }
  }
  showAll() {
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = false;
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.errorMessage = '';
    this.noContent = false;
    APP_SETTINGS.triBulletins = 'all';
    this.spinnerService.show('bmwSpinner');
    if (sessionStorage.getItem('triBulletinsStorageAll')) {
      let data = JSON.parse(sessionStorage.getItem('triBulletinsStorageAll'));
      this.triBulletins = data['content'];
      this.filterSeries(this.triBulletins);
      this.newDocsCount = data['newSize'];
      this.spinnerService.hide('bmwSpinner');
    } else {
      this.subscription.push(this.bulletinService.getAllTriBulletinService().subscribe(data => {
        this.triBulletins = data['content'];
        this.filterSeries(this.triBulletins);
        this.newDocsCount = data['newSize'];
        // this.changeDetector.detectChanges();
        sessionStorage.setItem('triBulletinsStorageAll', JSON.stringify(data));
        this.spinnerService.hide('bmwSpinner');
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      ));
    }
  }
  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.noContent = false;
    APP_SETTINGS.triBulletins = 'even';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getNewTriBulletinService().subscribe(data => {
      this.triBulletins = data;
      this.filterSeries(this.triBulletins);
      this.newDocsCount = this.triBulletins.length;
      if (this.newDocsCount === 0) {
        this.errorMessage = 'No New TRI Bulletins';
        this.noContent = true;
        if (this.redirectOnFirstVisit === true) {
          this.redirectOnFirstVisit = false;
          this.spinnerService.hide('bmwSpinner');
          this.showAll();
        }
      }
      // this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.isShowSaved = false;
    this.errorMessage = '';
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.noContent = false;
    APP_SETTINGS.triBulletins = 'history';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getHistoryTriBulletinService(this.username).subscribe(data => {
      this.triBulletins = data;
      this.filterSeries(this.triBulletins);
      if (this.triBulletins.length === 0) {
        this.errorMessage = 'No History Found';
        this.noContent = true;
      }
      // this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showSaved() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.isShowSaved = true;
    this.inputSeries = undefined;
    this.inputSeriesGroup = undefined;
    this.errorMessage = '';
    this.noContent = true;
    APP_SETTINGS.triBulletins = 'saved';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.bulletinService.getUserSavedTRIBulletins(this.username).subscribe(data => {
      this.triBulletins = data;
      this.filterSeries(this.triBulletins);
      if (this.triBulletins.length === 0) {
        this.errorMessage = 'No Saved Bulletins';
      }
      // this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }

  filterSeries(series: string[]) {
    let seriesArray = [];
    series.forEach(element => {
      if (element.hasOwnProperty('series')) {
        let tempSeries = element['series'];
        if (tempSeries.length > 0) {

          for (let i = 0; i < tempSeries.length; i++) {
            seriesArray.push(tempSeries[i].seriesName);
          }
        }
      }
    });
    let uniqueSeries = seriesArray.filter(function (item, index) {
      return seriesArray.indexOf(item) >= index;
    });
    this.inputSeriesGroup = uniqueSeries != null ? uniqueSeries.sort() : uniqueSeries;
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  addBulletinToHistory(isSaved, id) {
    this.bulletinService.saveFilterData(this.search4bulletins);
    if (!isSaved) {
      // this.subscription.push(this.bulletinService.addBulletinToUserHistory(this.username, id).subscribe());
    }
  }
  sortByProperty(propertyParam) {
    this.isDesc = !this.isDesc; // change the direction
    this.column = propertyParam;
    this.direction = this.isDesc ? 1 : -1;
  }
  updateBodyValues() {
    if (this.inputSeries.trim() !== '') {
      this.subscription.push(this.searchResultsService.getSeriesToBody().subscribe(value => {
        const bulletinWithUserInputSeries = value.find(item => item.seriesName === this.inputSeries.trim().toUpperCase());
        this.bodyTypeList = bulletinWithUserInputSeries ? bulletinWithUserInputSeries.bodies : this.initializeBodyTypes();
      }));
    } else {
      this.bodyTypeList = this.initializeBodyTypes();
    }
  }
  applyFilter() {
    let mainGroupCode = '';
    if (this.inputMainGroup) {
      const matchString = this.inputMainGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupCode = matchString;
      } else {
        mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
      }
    }
    this.inputSeries = this.inputSeries != undefined ? this.inputSeries.trim() : '';
    this.filter = {
      group: mainGroupCode.toString(),
      series: this.inputSeries,
      body: this.inputBody,
      from: this.inputFromYear,
      to: this.inputToYear
    };
    if (this.inputSortBy && this.inputSortBy.length > 0) {
      this.sortByProperty(this.inputSortBy);
    } else {
      this.isDesc = true;
      this.sortByProperty('bulletinIdForSort');
    }
  }
  clearFilter() {
    this.inputMainGroup = this.inputBody = this.inputSortBy = this.inputSeries = undefined;
    this.inputFromYear = this.inputToYear = '';
    this.filter = { group: '', series: '', body: '', from: '', to: '' };
  }
  initializeBodyTypes() {
    return [
      { id: 0, name: 'Compact' },
      { id: 1, name: 'Convertible' },
      { id: 2, name: 'GT' },
      { id: 3, name: 'HatchBack' },
      { id: 4, name: 'SAV' },
      { id: 5, name: 'Sedan' },
      { id: 6, name: 'Sports Wagon' },
      { id: 7, name: 'Touring' },
      { id: 8, name: 'Wagon' },
      { id: 9, name: 'Coupe' },
      { id: 10, name: 'Roadster' }
    ];
  }
  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

}
